import { useMemo, useState, useEffect, useCallback } from "react";
import { orderMock } from "../../mocks/orderMocks";
import { ProductProps } from "@/types";
import { CartItems } from "@/hooks/CartContext";

import { useGlobals } from "@/hooks";
import { useNetworkStatusContext } from "@/hooks";

import { useClient } from "@/hooks";
import { useDbFunctions } from "../dbFunctions/useDBFunctions";
interface CartProductItem {
    item: CartItems;
    product: ProductProps | undefined;
}

export const useSuccessPage = () => {
    const [orderItems, setOrderItems] = useState<any>(null);
    const [orderData, setOrderData] = useState<any>(null);
    const [cartTotals, setCartTotals] = useState<any>(null);

    const { selectedClientAddress } = useClient();
    const { connectivityStatus } = useNetworkStatusContext();
    const { setCanAccessSuccess, cartTotals: checkoutCartTotals, orderData: checkoutOrderData, orderItems: checkoutOrderItems } = useGlobals();

    const { getOnDB } = useDbFunctions();

    useEffect(() => {
        const fetchOrderData = async () => {
            try {
                if (checkoutCartTotals && checkoutOrderData && checkoutOrderItems) {
                    setOrderData(checkoutOrderData);
                    setCartTotals(checkoutCartTotals);
                    setOrderItems(checkoutOrderItems);
                }
            } catch (error) {
                console.error("Erro ao carregar os dados do IndexedDB:", error);
            }
        };

        fetchOrderData();
    }, [getOnDB, checkoutCartTotals, checkoutOrderData, checkoutOrderItems]);

    // Construção dos dados de envio e pagamento
    const shippingData = useMemo(() => {
        if (selectedClientAddress && orderData) {
            return [
                {
                    dataType: "address",
                    ...selectedClientAddress
                },
                {
                    dataType: "shipping",
                    carrier_code: "freeshipping",
                    carrier_title: orderMock.shipping_method,
                    amount: { currency: "BRL", value: 0 },
                    method_code: "freeshipping",
                    method_title: "Free"
                },
                {
                    dataType: "payment",
                    total: orderData?.orders?.total,
                    method: orderData?.orders?.payment_terms
                }
            ];
        }
        return null;
    }, [selectedClientAddress, orderData]);

    //orderData

    const orderNumber = useMemo(() => {
        if (orderData) return orderData.orders?.order_number;
        return null;
    }, [orderData]);

    const orderDate = useMemo(() => {
        if (orderData) return orderData.orders?.orderDate;
    }, [orderData]);

    const productList = useMemo(() => {
        if (!orderItems?.length) return orderItems;

        const pendingItems = orderData?.orders?.actions_pending;
        if (!pendingItems?.length) return orderItems;

        return orderItems.map((entry: CartProductItem & { checkoutPricing?: unknown }) => {
            if (entry.checkoutPricing) return entry;

            const payloadLine = pendingItems.find(
                (line: { sku?: string; packaging?: string }) =>
                    String(line.sku) === String(entry.item?.sku) &&
                    line.packaging === entry.item?.option_uid
            ) as { price?: string; unit_price?: string; unit_price_per_item?: string; promotion_type?: string } | undefined;

            if (!payloadLine?.price) return entry;

            const lineTotal = Number(payloadLine.price);
            const unitPrice = Number(payloadLine.unit_price);
            const packQty = Number(entry.item?.option_uid?.split('_')[1] || 1);

            return {
                ...entry,
                checkoutPricing: {
                    lineTotal,
                    unitPrice,
                    unitPricePerItem: Number(payloadLine.unit_price_per_item) || unitPrice / packQty,
                    originalLineTotal: lineTotal,
                    hasComboDiscount: Boolean(payloadLine.promotion_type),
                },
            };
        });
    }, [orderItems, orderData]);


    return {
        shippingData,
        orderNumber,
        orderDate,
        productList,
        connectivityStatus,
        setCanAccessSuccess,
        cartTotals
    }

}
